import React, { useMemo } from 'react';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import { AuthPageStyles } from '../../../utilities/themeColors';
import { resolveServiceOptions } from '../../../utilities/customerLocationSettings';
import { useOptions } from '../../../context/optionContext';
import { useTranslation } from 'react-i18next';
import { useSite } from '../../../context/siteContext';
import useBrandingAssets from '../../../hooks/useBrandingAssets';

const Training = () => {
    const { t } = useTranslation();
    const { selectedSiteData } = useSite();
    const { optionKeys } = useOptions();
    const { authBackdropStyle } = useBrandingAssets();

    const amfMethodConfig = useMemo(
        () => resolveServiceOptions(optionKeys).find((service) => service.key === "amfmethod_premium"),
        [optionKeys]
    );

    const hasAmfServiceEnabled = Boolean(selectedSiteData?.services_meta?.amfmethod_premium);
    const amfPortalUrl = amfMethodConfig?.href;

    return (
        <Box sx={{ p: 2, pt: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <PageTitle title={t('LABELS.TRAINING')} />
            <Box sx={{
                ...(authBackdropStyle || AuthPageStyles), height: '100%',
                minHeight: '80vh',
                width: '100%',
                minWidth: '100vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center', overflow: 'hidden'
            }}>

                <Box
                    sx={{
                        position: 'relative',
                        zIndex: 2,
                        height: '100%',
                        width: '100%',
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 3,
                    }}
                >
                    {hasAmfServiceEnabled && amfPortalUrl ? (
                        <Card sx={{ maxWidth: 420, width: '100%', textAlign: 'center', boxShadow: 4 }}>
                            <CardContent>
                                <Typography variant="h5" fontWeight={700} gutterBottom>
                                    AMFMethod Premium
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                    Access the AMFMethod Premium portal for training resources and content tailored to your site.
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => window.open(amfPortalUrl, "_blank", "noopener,noreferrer")}
                                >
                                    Login to Portal
                                </Button>
                            </CardContent>
                        </Card>
                    ) : (
                        <Typography variant="h1" fontSize={"40px"} color="#fff" textAlign="center">
                            {t('UI_TEXT.COMING_SOON')}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default Training;
